export const environment = {
  production: true,
  domainName: window.location.hostname,
  apiUrl: 'https://' + window.location.hostname + '/proxy',
  helpUrl: 'https://help.papertrl.com/',
  vendorCommunityUrl: 'https://vendors.papertrl.com/#/',
  exusPartner: 'exus',
  demoEnv: false,
  gtag: 'G-KG27KEFQTP',
  env: 'Production'
};
